import { createAction } from "redux-actions";
import {
    SET_SHOW_DOORS,
    DRAG_DIMENSION_VALUE,
    SELECT_ALL_TOGGLE,
    SORT_ASCENDING,
    SORT_DESCENDING,
    MOVE_METRIC,
    SET_METRICS_FROM_SCHEMA,
    SET_SHOW,
    TOGGLE_ASSORTMENT_TOTALS,
    TOGGLE_METRIC,
    TOGGLE_SWITCH,
    MOVE_ATTRIBUTE,
    TOGGLE_DIMENSION_VALUE,
    TOGGLE_ATTRIBUTE_LABEL,
    SET_DRAFT,
    TOGGLE_PLAN_TOTALS,
} from "./constants";
import {
    SetShowDoors,
    DragDimensionValue,
    DimensionPanelDefaultAction,
    MoveMetric,
    SetMetricsFromSchema,
    SetShow,
    ToggleAssortmentTotals,
    ToggleMetric,
    ToggleSwitch,
    MoveAttribute,
    ToggleDimensionValue,
    ToggleAttributeLabel,
    SetDraft,
    TogglePlanTotals,
} from "./types";

export const setDraft: SetDraft = createAction(SET_DRAFT);
export const setShowDoors: SetShowDoors = createAction(SET_SHOW_DOORS);
export const dragDimensionValue: DragDimensionValue = createAction(DRAG_DIMENSION_VALUE);
export const selectAllValues: DimensionPanelDefaultAction = createAction(SELECT_ALL_TOGGLE);
export const toggleDimensionValue: ToggleDimensionValue = createAction(TOGGLE_DIMENSION_VALUE);
export const sortAscending: DimensionPanelDefaultAction = createAction(SORT_ASCENDING);
export const sortDescending: DimensionPanelDefaultAction = createAction(SORT_DESCENDING);

export const setMetricsFromSchema: SetMetricsFromSchema = createAction(SET_METRICS_FROM_SCHEMA);
export const setShow: SetShow = createAction(SET_SHOW);
export const toggleMetric: ToggleMetric = createAction(TOGGLE_METRIC);
export const toggleSwitch: ToggleSwitch = createAction(TOGGLE_SWITCH);
export const moveMetric: MoveMetric = createAction(MOVE_METRIC);
export const moveAttribute: MoveAttribute = createAction(MOVE_ATTRIBUTE);
export const toggleAssortmentTotals: ToggleAssortmentTotals = createAction(TOGGLE_ASSORTMENT_TOTALS);
export const toggleAttributeLabel: ToggleAttributeLabel = createAction(TOGGLE_ATTRIBUTE_LABEL);
export const togglePlanTotals: TogglePlanTotals = createAction(TOGGLE_PLAN_TOTALS);
